<template lang="pug">
  .tpagination
    .prev(@click="prev(currentPage - 1)")
      font-awesome-icon.arrow(icon="angle-left" size="lg" :class="{disabled: currentPage === 1}")
    .options(v-if="fullDataModal") You are viewing page
      el-input.page-input(v-model="page" @change="setPage" :min="1" :max="lastPage" type="number")
      | of {{lastPage}} with {{perPage}}
      | {{entities}} per page
    .options(v-else) You are viewing page
      el-input.page-input(v-model="page" @change="setPage" :min="1" :max="lastPage" type="number")
      | of {{lastPage}} with
      el-select.item-select(@change="val => $emit('set-per-page', val)" :value="perPage")
        el-option(v-for="size in sizes" :key="size" :label="size" :value="size")
      | {{entities}} per page
    .options.mobile You are viewing page {{currentPage}} of {{lastPage}} with {{perPage}} {{entities}} per page
    .next(@click="next(currentPage + 1)")
      font-awesome-icon.arrow(icon="angle-right" size="lg" :class="{disabled:currentPage === lastPage}")
</template>
<script>
import clone from 'lodash/clone'

export default {
  props: {
    sizes: {
      type: Array,
      default: () => [
        5,
        10,
        15,
        50,
      ],
    },
    perPage: {
      type: [ Number, String, ],
      default: 15,
    },
    lastPage: {
      type: [ Number, String, ],
      default: 1,
    },
    currentPage: {
      type: [ Number, String, ],
      default: 1,
    },
    entities: {
      type: String,
      default: 'records',
    },
    fullDataModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: null,
  }),
  created () {
    this.page = clone(this.currentPage)
  },
  methods: {
    setPage (val) {
      if (val > this.lastPage) {
        this.$emit('set-page', this.lastPage)
        this.page = this.lastPage
      }
      else {this.$emit('set-page', val)}
    },
    prev (val) {
      this.page = Math.max(1, val)
      if (val > 0) this.$emit('prev', val)
    },
    next (val) {
      this.page = Math.min(this.lastPage, val)
      if (val <= this.lastPage) this.$emit('prev', val)
    },
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .tpagination
    width 100%
    margin-top 30px
    display flex
    justify-content space-between
    align-items center

    .prev, .next
      width 24px

    .arrow
      font-size 3rem
      cursor pointer
      color $default-color-middle-1

      &:hover
        color $turquoise-color

      &.disabled
        color $default-color-light-1

        &:hover
          cursor not-allowed

    .options
      display flex
      align-items center
      color $default-color-bold

      &.mobile
        display none

    .page-input, .item-select, .el-input
      width 70px
      height 40px

      .el-input__inner
        width 100%
        height 100%
        padding 0 5px
        font-size 1rem
        font-weight 600
        text-align center
        border-radius none
        background-color $default-color-light-2
        border 1px solid $default-color-light-1
        color $default-color-bold

    .page-input, .item-select
      margin 0 8px

    .page-input
      .el-input__inner
        padding 0 5px 0 12.5px

    .item-select .el-input
      .el-input__inner
        padding 0 15px 0 5px

  @media screen and (max-width: $laptop)
    .tpagination
      margin 0 0 20px
      order 2

  @media screen and (max-width: $tablet)
    .tpagination
      display flex
      justify-content space-between
      align-items center

      .prev
        order 2
        margin-right 12px

      .next
        order 3

      .prev, .next
        width 24px

      .arrow
        font-size 3rem

      .options
        display none

        &.mobile
          flex 1
          font-size 80%
          line-height 1rem
          padding-right 30px
          display flex
</style>



// WEBPACK FOOTER //
// src/components/data-table/TPagination.vue